import React from 'react';
import { useHistory } from 'react-router-dom';

import './product-detail-category-style.scss';
import Button from '@src/componentsNew/Buttons/Button';
import { product_product_category } from '@components/ProductPage/ProductDetailPage/__generated__/product';

import { goToUrl } from '@src/utils/urlCheck';

interface IProps {
  category: product_product_category | null;
}

const ProductDetailCategory = ({ category }: IProps) => {
  const history = useHistory();

  return category ? (
    <div className="product-detail-category-wrapper">
      {category?.parent?.parent && (
        <>
          <Button size="small">{category.parent.parent.name}</Button>
          <span>|</span>
        </>
      )}
      {category?.parent && (
        <>
          <Button size="small" onClick={() => goToUrl(history, category.parent.url)}>
            {category.parent.name}
          </Button>
          <span>|</span>
        </>
      )}
      <Button size="small" onClick={() => goToUrl(history, category.url)}>
        {category.name}
      </Button>
    </div>
  ) : null;
};

export default ProductDetailCategory;
